import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "panel", "label"]

  connect() {
    this.closeHandler = (event) => {
      if (!this.element.contains(event.target)) this.hide()
    }
    document.addEventListener("click", this.closeHandler)
  }

  disconnect() {
    document.removeEventListener("click", this.closeHandler)
  }

  toggle() {
    this.panelTarget.classList.toggle("hidden")
  }

  hide() {
    this.panelTarget.classList.add("hidden")
  }

  updateLabel() {
    const checked = this.panelTarget.querySelectorAll("input[type=checkbox]:checked")
    if (checked.length === 0) {
      this.labelTarget.textContent = this.labelTarget.dataset.placeholder || "Tous"
      this.labelTarget.classList.add("text-text-muted")
      this.labelTarget.classList.remove("text-text-primary")
    } else {
      const labels = Array.from(checked).map(cb => cb.closest("label").textContent.trim())
      this.labelTarget.textContent = labels.join(", ")
      this.labelTarget.classList.remove("text-text-muted")
      this.labelTarget.classList.add("text-text-primary")
    }
  }
}
